"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.suspendedUsersTableConf = exports.surveyUsersTableConf = exports.invitedUsersTableConf = exports.activeUsersTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var date_fns_1 = require("date-fns");
var constants_1 = require("containers/TableMaker/constants");
var AccessLevelDropdown_1 = __importDefault(require("./ActiveUsers/AccessLevelDropdown"));
var TeamsDropdown_1 = __importDefault(require("./ActiveUsers/TeamsDropdown"));
var constants_2 = require("./constants");
var DetailedInviteDropdown_1 = __importDefault(require("./InvitedUsers/DetailedInviteDropdown"));
var TeamsDropdown_2 = __importDefault(require("./InvitedUsers/TeamsDropdown"));
var ReactivateUserDropdown_1 = __importDefault(require("./SuspendedUsers/ReactivateUserDropdown"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
exports.activeUsersTableConf = {
    headersMap: {
        name: 'User',
        companyAccessLevel: 'Access Level',
    },
    extractors: {
        name: function (item) { return (0, end2end_1.getDisplayName)(item) || item.email; },
        email: function (item) { return (0, end2end_1.getDisplayName)(item) ? item.email : undefined; },
        team: function (item) { var _a; return (_a = item.companyTeam) === null || _a === void 0 ? void 0 : _a.name; },
        companyAccessLevel: function (item) { var _a; return item.accessLevel && ((_a = constants_2.ACC_LVL_PROPS_MAPPER[item.accessLevel]) === null || _a === void 0 ? void 0 : _a.title); }, // needs tweaking
    },
    cells: [
        { cell: { width: XL + SM, offset: 'left', growCell: true }, fields: ['name', 'email'] },
        !end2end_1.IS_RECHARGLY && { cell: { width: XL, textAlign: 'right' }, field: 'team', renderComponent: TeamsDropdown_1.default },
        {
            cell: { width: XL + SM, textAlign: 'right', offset: 'right' }, field: 'companyAccessLevel', renderComponent: AccessLevelDropdown_1.default,
        },
        { cell: { width: 12, isActionCell: true }, key: 'extra' },
    ].filter(end2end_1.notFalsy),
};
exports.invitedUsersTableConf = {
    headersMap: exports.activeUsersTableConf.headersMap,
    extractors: {
        email: function (item) { return item.email; },
        team: function (item) { var _a; return (_a = item.companyTeam) === null || _a === void 0 ? void 0 : _a.name; },
        companyAccessLevel: function (item) { var _a; return item.accessLevel && ((_a = constants_2.ACC_LVL_PROPS_MAPPER[item.accessLevel]) === null || _a === void 0 ? void 0 : _a.title); }, // needs tweaking
    },
    cells: [
        { cell: { width: XL + SM, offset: 'left', growCell: true }, fields: ['email', 'name'] },
        !end2end_1.IS_RECHARGLY && { cell: { width: XL, textAlign: 'right' }, field: 'team', renderComponent: TeamsDropdown_2.default },
        {
            cell: { width: XL + SM, textAlign: 'right' },
            field: 'companyAccessLevel',
            renderComponent: DetailedInviteDropdown_1.default,
        },
        { cell: { width: 12, isActionCell: true }, key: 'extra' },
    ].filter(end2end_1.notFalsy),
};
exports.surveyUsersTableConf = {
    headersMap: {
        name: 'User',
        reviewed: 'Survey Status',
    },
    extractors: {
        name: function (item) { return (0, end2end_1.getDisplayName)(item) || item.email; },
        email: function (item) { return (0, end2end_1.getDisplayName)(item) ? item.email : undefined; },
        team: function (item) { var _a; return (_a = item.companyTeam) === null || _a === void 0 ? void 0 : _a.name; },
        reviewed: function (item) { return item.reviewsStep === interfaces_1.REVIEWS_STEP.ReviewsDone ? 'Completed' : 'Incomplete'; },
        sentDate: function (item) { var _a, _b, _c; return ((_a = item.invitation) === null || _a === void 0 ? void 0 : _a.sentAt) && (0, date_fns_1.format)((_c = (_b = item.invitation) === null || _b === void 0 ? void 0 : _b.sentAt) === null || _c === void 0 ? void 0 : _c.toDate(), 'dd-MM-yyyy'); },
    },
    cells: [
        { cell: { width: XL + XS, offset: 'left' }, fields: ['name', 'email'] },
        { cell: { width: XL }, field: 'team' },
        { cell: { width: LG }, field: 'reviewed' },
        { cell: { width: LG, textAlign: 'right' }, field: 'sentDate' },
    ],
};
exports.suspendedUsersTableConf = __assign(__assign({}, exports.activeUsersTableConf.headersMap), { extractors: {
        name: function (item) { return (0, end2end_1.getDisplayName)(item) || item.email; },
        email: function (item) { return (0, end2end_1.getDisplayName)(item) ? item.email : undefined; },
        team: function (item) { var _a; return (_a = item.companyTeam) === null || _a === void 0 ? void 0 : _a.name; },
        companyAccessLevel: function (item) { var _a; return item.accessLevel && ((_a = constants_2.ACC_LVL_PROPS_MAPPER[item.accessLevel]) === null || _a === void 0 ? void 0 : _a.title); }, // needs tweaking
    }, cells: [
        { cell: { width: XL + XS, offset: 'left', growCell: true }, fields: ['name', 'email'] },
        !end2end_1.IS_RECHARGLY && { cell: { width: XL + XS }, field: 'team' },
        { cell: { width: XL + SM, textAlign: 'right' }, field: 'accessLevel', renderComponent: ReactivateUserDropdown_1.default },
        { cell: { width: 12, isActionCell: true }, key: 'extra' },
    ].filter(end2end_1.notFalsy) });
